import * as React from 'react';
import type { Trip } from 'contracts/tracking-v2/trips';
import { api, handleApiError } from 'services/api';

export const useFetchTrip = () => {
  const fetchTrip = React.useCallback(async (tripId: string | number) => {
    try {
      const url = `/tracking-v2/trips/${tripId}`;
      const { data } = await api.get<Trip>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchTrip,
  };
};